import { api } from "@/common/lib/api";
import { useMutation } from "@tanstack/react-query";

type GenericOk = { ok: true; message: string };

type AccessRequestInput = { email: string; phone: string };

export function useCreateAccessRequest() {
  return useMutation<GenericOk, Error, AccessRequestInput>({
    mutationFn: (input) => api.post<GenericOk>("/access-requests", input),
  });
}

type RequestLoginLinkInput = { email: string; invitationToken?: string };

export function useRequestLoginLink() {
  return useMutation<GenericOk, Error, RequestLoginLinkInput>({
    mutationFn: (input) => api.post<GenericOk>("/auth/request-login-link", input),
  });
}

export type BootstrapResponse = {
  user: { id: string; email: string; firebaseUid: string; isActive: boolean };
  acceptedInvitation?: { accountId: string };
};

type BootstrapInput = { invitationToken?: string };

export function useBootstrap() {
  return useMutation<BootstrapResponse, Error, BootstrapInput>({
    mutationFn: (input) =>
      api.post<BootstrapResponse>("/auth/bootstrap", input.invitationToken ? input : {}),
  });
}
